import { Conduit } from '@campingvision/conduit';
import { authentication } from '../../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}booking/ski/school/`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {
  /**
   * @param bookingId
   * @returns {AxiosPromise}
   */
  getSkiSchoolByBookingId(bookingId) {
    return conduit.get(`booking/${bookingId}`);
  },

  /**
   * @param bookingParticipantId
   * @param skiSchool
   * @returns {AxiosPromise}
   */
  createSkiSchool(bookingParticipantId, skiSchool) {
    return conduit.post(`booking-participant/${bookingParticipantId}/create`, { skiSchool });
  },

  /**
   * @param skiSchool
   * @returns {AxiosPromise}
   */
  updateSkiSchool(skiSchool) {
    return conduit.put(`${skiSchool.id}/update`, { skiSchool });
  },

  /**
   * @param skiSchoolPrice
   * @returns {AxiosPromise}
   */
  updateSkiSchoolPrice(skiSchoolPrice) {
    return conduit.put(`${skiSchoolPrice.id}/update-price`, { skiSchoolPrice });
  },

  /**
   * @param skiSchoolId
   * @param cancellationFeeNet
   * @returns {AxiosPromise}
   */
  updateSkiSchoolCancellationFeeNet(skiSchoolId, cancellationFeeNet) {
    return conduit.patch(`${skiSchoolId}/cancellation-fee-net`, { cancellationFeeNet });
  },


  /**
   * @param skiSchoolId
   * @param supplierRef
   * @returns {AxiosPromise}
   */
  updateSkiSchoolWithSupplierRef(skiSchoolId, supplierRef) {
    return conduit.put(`${skiSchoolId}/supplier-ref`, { supplierRef });
  },

  /**
   * @param skiSchoolId
   * @returns {AxiosPromise}
   */
  reopenSkiSchool(skiSchoolId) {
    return conduit.put(`${skiSchoolId}/reopen`);
  },

  /**
   * @param skiSchoolId
   * @param skiSchoolMeetingPointRequestDTO
   * @returns {AxiosPromise}
   */
  updateSkiSchoolWithMeetingPoint(skiSchoolId, skiSchoolMeetingPointRequestDTO) {
    return conduit.put(`${skiSchoolId}/meeting-point`, { skiSchoolMeetingPointRequestDTO });
  },

  /**
   * @param skiSchoolId
   * @param startDateTime
   * @returns {AxiosPromise}
   */
  updateSkiSchoolWithStartDateTime(skiSchoolId, startDateTime) {
    return conduit.put(`${skiSchoolId}/start-date-time`, { startDateTime });
  },

  /**
   * @param skiSchoolId
   * @param comment
   * @returns {AxiosPromise}
   */
  updateSkiSchoolWithSupplierComment(skiSchoolId, comment) {
    return conduit.put(`${skiSchoolId}/supplier-comment`, { comment });
  },

  /**
   * @param skiSchoolId
   * @param comment
   * @returns {AxiosPromise}
   */
  updateSkiSchoolWithCustomerComment(skiSchoolId, comment) {
    return conduit.put(`${skiSchoolId}/customer-comment`, { comment });
  },

  /**
   * @param skiSchoolId
   * @param salesAgentUserId
   * @returns {AxiosPromise}
   */
  cancelSkiSchool(skiSchoolId, salesAgentUserId) {
    return conduit.delete(`${skiSchoolId}/sales-agent/${salesAgentUserId}/cancel`);
  },

  /**
   * @param skiSchoolId
   * @param salesAgentUserId
   * @returns {AxiosPromise}
   */
  stopSkiSchool(skiSchoolId, salesAgentUserId) {
    return conduit.delete(`${skiSchoolId}/sales-agent/${salesAgentUserId}/stop`);
  },

  /**
   * @param skiSchoolId
   * @param salesAgentUserId
   * @returns {AxiosPromise}
   */
  deleteSkiSchool(skiSchoolId, salesAgentUserId) {
    return conduit.delete(`${skiSchoolId}/sales-agent/${salesAgentUserId}/delete`);
  },

  /**
   * @param skiSchoolId
   * @param bookingParticipantId
   * @returns {AxiosPromise}
   */
  createSkiSchoolParticipant(skiSchoolId, bookingParticipantId) {
    return conduit.post(`${skiSchoolId}/participant/${bookingParticipantId}/add`);
  },

  /**
   * @param skiSchoolId
   * @param bookingParticipantId
   * @returns {AxiosPromise}
   */
  deleteSkiSchoolParticipant(skiSchoolId, bookingParticipantId) {
    return conduit.delete(`${skiSchoolId}/participant/${bookingParticipantId}/delete`);
  },

  /**
   * @param bookingId
   * @returns {AxiosPromise}
   */
  sendSkiSchoolRequestEmail(bookingId) {
    return conduit.post('send-supplier-request', { bookingId });
  },
};



// WEBPACK FOOTER //
// ./src/services/ski/booking-ski-school-service.js